import { Box, Button, useTheme } from "@mui/material";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { ReminderSnoozeOptions } from "web_myplann/Reminders/Components/ReminderSnoozeOptions";
import { useReminderSnoozeForm } from "web_myplann/Reminders/Hooks/useReminderSnoozeForm";
import type { Reminder } from "web_myplann/Reminders/Types/ReminderTypes";
import { getSnoozeBaseDate } from "web_myplann/Reminders/Utils/snoozeDates";
import { MyPlannDrawer } from "web_myplann/Shared/Components/MyPlannDrawer";

type Props = {
	reminder: Reminder;
	open: boolean;
	onClose: () => void;
};

export const ReminderSnoozeDrawer = ({ reminder, open, onClose }: Props) => {
	const { t } = useResource();
	const { spacingTokens, bottomSpacing } = useTheme();

	const { form, submit, isSubmitting } = useReminderSnoozeForm({
		reminder,
		onSuccess: onClose,
	});
	const { control, formState } = form;

	const minSnoozeDate = getSnoozeBaseDate(reminder.date);

	return (
		<MyPlannDrawer
			open={open}
			onClose={onClose}
			title={t(Resources.Reminders.Snooze.title)}
			grabber
		>
			<Box px={spacingTokens.lg} pt={spacingTokens.xs} pb={bottomSpacing.sheet}>
				<ReminderSnoozeOptions
					control={control}
					minSnoozeDate={minSnoozeDate}
				/>

				<Button
					variant="primary"
					onClick={submit}
					disabled={!formState.isValid}
					loading={isSubmitting}
					sx={{ mt: spacingTokens.lg }}
				>
					{t(Resources.Reminders.Snooze.confirm)}
				</Button>
			</Box>
		</MyPlannDrawer>
	);
};
